import { render } from "./NotificationMessage.vue?vue&type=template&id=875da09c"
import script from "./NotificationMessage.vue?vue&type=script&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&lang=js"

import "./NotificationMessage.vue?vue&type=style&index=0&id=875da09c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/common/header/parts/NotificationMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "875da09c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('875da09c', __exports__)) {
    api.reload('875da09c', __exports__)
  }
  
  module.hot.accept("./NotificationMessage.vue?vue&type=template&id=875da09c", () => {
    api.rerender('875da09c', render)
  })

}


export default __exports__